import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgInProgress(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M20 8a8 8 0 01-14.583 4.547l-.157-.235-.157-.26-.06-.1a7.98 7.98 0 01-.17-.315l-.03-.056a7.96 7.96 0 01-.442-1.074L6.3 9.88a6 6 0 108.165-7.352l-.234-.1.644-1.896A8.003 8.003 0 0120 8zM5.154 12.14l.106.172-.03-.048-.076-.123zm.948-5.25c-.094.5-.124 1.01-.09 1.516l-1.994.132a8.12 8.12 0 01.118-2.017l1.966.368zm.703 4.115l.019.032.082.133-.1-.165zm8.983-4.797C12.738 9.4 11.143 10.996 11 11s-1.13-.84-2.965-2.53l1.1-1.1L11 9.02l3.618-3.832zM7.354 4.202a6.004 6.004 0 00-.798 1.27L4.743 4.63a8.004 8.004 0 011.064-1.694l1.547 1.267zM9.03.57l.743 1.857c-.466.186-.906.43-1.31.727L7.28 1.54A7.985 7.985 0 019.029.57zm3.96-.51l-.244 1.986a6.062 6.062 0 00-1.515.003L10.977.065A8.077 8.077 0 0112.99.06z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('InProgress')(SvgInProgress);
